import {useEffect, useState} from "react";
import './Question.css';
import PropTypes from "prop-types";
import {ANSWER_LAG_TIME} from "./QuestionUtil.jsx";

Question.propTypes = {
  question: PropTypes.object.isRequired,
  onAnswer: PropTypes.func
};


/*
function shuffle(answers) {
  return answers.sort(() => Math.random() - 0.5);
}
*/

function annotate(answers) {
  return answers.map((answer, index) => {
    return {
      ...answer,
      text: `${String.fromCharCode(65 + index)}. ${answer.text}`
    }
  });
}

export default function Question({question, onAnswer}) {

  const [selectedAnswer, setSelectedAnswer] = useState();
  useEffect(() => {
    setSelectedAnswer(null);
  }, [question]);

  const [overlay, setOverlay] = useState();

  function handleSelectAnswer(answer) {
    if (!selectedAnswer) {
      setSelectedAnswer(answer);
      if (answer.correct) {
        setOverlay("green");
      } else {
        setOverlay("red");
      }
      let lagTime = answer.correct ? ANSWER_LAG_TIME.CORRECT : ANSWER_LAG_TIME.INCORRECT;
      setTimeout(() => setOverlay(null), lagTime);
    }
    if (onAnswer) {
      onAnswer(answer);
    }
  }

  function answerStyle(answer) {
    if (selectedAnswer) {
      if (answer.correct) {
        return "correct";
      } else if (answer.text === selectedAnswer.text) {
        return "incorrect";
      }
    }
    return "";
  }

  return (
    <div className="question-container">
      <div className={"question-overlay " + (overlay ?? "")}/>
      <div className="question-text-container">
        { question.question.map((line, index) => (
              <p key={index} className="question-text">{line}</p>
        ))}
        <img src="/img/chalkboard.jpg" alt="chalkboard" className="question-chalkboard-background"/>
      </div>
      <div className={`question-answers ${selectedAnswer ? "inactive" : "active"}`}>
        {annotate(question.answers).map((answer, index) => (
          <button key={index} className={`question-answer ${answerStyle(answer)}`}
                  onClick={() => handleSelectAnswer(answer)}>
            {answer.text}
          </button>
        ))
        }
      </div>
    </div>
  )
}